import MyAlert from "~/mui/MyAlert";
import { useTrans } from '~/hooks/useTrans';
import { IWysiwygContent, contentToHTML } from "~/components/Wysiwyg";
import { TextField } from "@mui/material";
import WysiwygDisplay from "~/components/WysiwygDisplay";

import "./style.less";

interface IEmailPreviewModal {
	content: IWysiwygContent;
	onClose?: () => void;
}

export default function EmailPreviewModal({
	content,
	onClose = () => {},
}: IEmailPreviewModal) {
	const { trans } = useTrans();
	const html = contentToHTML(content);

	return <MyAlert title={trans("emailPreviewModal.title")} onClose={onClose} cancelCaption={ trans("close") }>
		<WysiwygDisplay className="emailPreviewModal__preview" html={html} />
		<div>
			<TextField
				label={trans("emailPreviewModal.html")}
				value={html}
				style={{ width: "100%" }}
				multiline={true}
				color="success"
				autoComplete="off"
				rows={3}
			/>
		</div>
	</MyAlert>;
}
